<template>
  <StandardLogin/>
</template>

<script>
import StandardLogin from "@/components/StandardLogin.vue";

export default {
  components: { StandardLogin }
};
</script>
